export default "__VITE_ASSET__7e0a13ba__"